module.exports = __webpack_public_path__ + "static/naples-2017-4d46e5323f65b9406937881fe8782186.jpg";